if (!customElements.get('elvtd-countdown-timer')) {
  customElements.define(
    'elvtd-countdown-timer',
    class ElvtdCountdownTimer extends HTMLElement {
      connectedCallback() {
        this.endDate = parseInt(this.dataset.endTimestamp, 10) * 1000;
        this.daysEl = this.querySelector('[data-days]');
        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');

        this.update();
        this.interval = setInterval(this.update.bind(this), 1000);

        if (this.classList.contains('sticky')) {
          this.initStickyBehavior();
        }
      }

      disconnectedCallback() {
        clearInterval(this.interval);

        if (this.handleScroll) {
          window.removeEventListener('scroll', this.handleScroll);
          window.removeEventListener('resize', this.handleResize);
        }

        if (this.placeholder) {
          this.placeholder.remove();
        }
      }

      initStickyBehavior() {
        this.placeholder = document.createElement('div');
        this.placeholder.setAttribute('aria-hidden', 'true');
        this.placeholder.style.display = 'none';
        this.parentNode.insertBefore(this.placeholder, this);

        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.measureNaturalOffset();
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);
      }

      measureNaturalOffset() {
        const wasPinned = this.classList.contains('is-pinned');
        if (wasPinned) this.unpin();

        this.naturalOffsetTop = this.getBoundingClientRect().top + window.scrollY;
        this.naturalHeight = this.offsetHeight;

        if (wasPinned) this.pin();
      }

      handleResize() {
        this.measureNaturalOffset();
        this.handleScroll();
      }

      handleScroll() {
        if (window.scrollY >= 300) {
          this.pin();
        } else {
          this.unpin();
        }
      }

      pin() {
        if (this.classList.contains('is-pinned')) return;
        this.placeholder.style.height = `${this.naturalHeight}px`;
        this.placeholder.style.display = 'block';
        this.classList.add('is-pinned');
      }

      unpin() {
        if (!this.classList.contains('is-pinned')) return;
        this.classList.remove('is-pinned');
        this.placeholder.style.display = 'none';
      }

      update() {
        const remaining = this.endDate - Date.now();

        if (remaining <= 0) {
          clearInterval(this.interval);
          this.remove();
          return;
        }

        const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remaining / (1000 * 60)) % 60);
        const seconds = Math.floor((remaining / 1000) % 60);

        this.daysEl.textContent = String(days).padStart(2, '0');
        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }
  );
}
